import { render } from "./CopperLoyaltyModal.vue?vue&type=template&id=6899987e&scoped=true"
import script from "./CopperLoyaltyModal.vue?vue&type=script&lang=js"
export * from "./CopperLoyaltyModal.vue?vue&type=script&lang=js"

import "../../../assets/css/Modals/StoreModals/CopperLoyaltyModal.css?vue&type=style&index=0&id=6899987e&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6899987e"]])

export default __exports__